import { ColumnMappingBaseTransformPlainObject, RuleBasedMappingPlainObject } from './columnMappingBase.plainObject';

export class FoldDownPlainObject extends ColumnMappingBaseTransformPlainObject {
    public unrollRoot: string = '';
    public unrollBy: string = '';
    public unrollMultiple: string[] = [];
    public columns: RuleBasedMappingPlainObject[] = [];
}
